import React, { useState } from 'react';
import { I18n } from 'react-redux-i18n';
import './AgeDistributionChart.sass';

const AgeDistributionChart = ({ ageData = [] }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const maxValue = Math.max(...ageData.map((item) => item.total), 1);
  const totalPersons = ageData.reduce((sum, item) => sum + item.total, 0);

  return (
    <div className="age-distribution-chart">
      {ageData.map((item, index) => {
        const widthPercent = (item.total / maxValue) * 100;
        const percentage =
          totalPersons > 0
            ? Math.round((item.total / totalPersons) * 100)
            : 0;
        const personLabel =
          item.total === 1
            ? I18n.t('dashboard.person')
            : I18n.t('dashboard.persons');

        return (
          <div
            key={`age-bar-${index}`}
            className={`age-bar-row ${
              hoveredIndex !== null && hoveredIndex !== index
                ? 'age-bar-row--dimmed'
                : ''
            }`}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div className="age-bar-label">{item.name}</div>
            <div className="age-bar-track">
              <div
                className="age-bar-fill"
                style={{
                  width: `${widthPercent}%`,
                  animationDelay: `${index * 0.1}s`,
                }}
              >
                {hoveredIndex === index ? (
                  <div className="age-bar-tooltip" role="tooltip">
                    {`${item.total} ${personLabel} · ${percentage}%`}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="age-bar-value">{item.total}</div>
          </div>
        );
      })}
    </div>
  );
};

export default AgeDistributionChart;
